import { render } from "./FixtureTabs.vue?vue&type=template&id=13a57138"
import script from "./FixtureTabs.vue?vue&type=script&lang=js"
export * from "./FixtureTabs.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Pitch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__